import { ref, watch } from 'vue'
import { type CabinetMainType, useLoadCabinet } from '@/entities/Cabinet'

/**
 * Модель для шкафов
 * @param cabinet_id
 */
export const useMapCabinet = (cabinet_id: number) => {
  const cabinet = ref<CabinetMainType | null>(null)

  /**
   * Функция загрузки данных шкафа
   */
  const loadCabinet = () => {
    const result = useLoadCabinet(cabinet_id)

    watch(result.data, () => {
      if (result.data.value) cabinet.value = result.data.value.data
    })

    return result
  }

  return {
    cabinet,

    loadCabinet,
  }
}
